import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
// import Navbar from "./../NavBar";
import axios from "axios";
// import Announcementslider from './Announcementslider.jsx';
import CustomNavbar from "../CustomPermissions/CustomNavbar";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

function DocladderPrevMonthRecords() {
  const [data, setData] = useState(null);
  const [dailyEntryData, setDailyEntryData] = useState([]);
  const [isSuperuser, setIsSuperuser] = useState(false);
  const [pipelineandturnedup, setPipelineandturnedup] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accessToken = localStorage.getItem("access_token");
        if (accessToken) {
          const response = await axios.get(
            getApiUrl("/Docladder/PrevMonth_records_list/", false),
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          );

          const {
            records,
            monthly_records,
            is_superuser,
            user_permissions,
            pipelineandturnedup,
          } = response.data;

          setData(records || []);
          setDailyEntryData(monthly_records || []);
          setIsSuperuser(is_superuser);
          setPipelineandturnedup(pipelineandturnedup || []);

          if (is_superuser) {
            // Superuser logic
          } else if (user_permissions) {
            // handlePermissionNavigation(user_permissions);
          }
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation");
      }
    };

    fetchData();
  }, [navigate]);

  const sortedData = useMemo(() => {
    if (!dailyEntryData || !pipelineandturnedup) return [];

    return dailyEntryData.sort((a, b) => {
      // Sorting logic here
    });
  }, [dailyEntryData, pipelineandturnedup]);

  // Calculate the totals for each column
  const totalForwarded = sortedData.reduce(
    (acc, curr) => acc + curr.resume_forwarded,
    0
  );
  const totalPipeline = sortedData.reduce((acc, curr) => {
    const pipeline =
      pipelineandturnedup.find((entry) => entry.user === curr.user)?.pipline ||
      0;
    return acc + pipeline;
  }, 0);
  const totalTurnedUp = sortedData.reduce(
    (acc, curr) => acc + curr.turned_up,
    0
  );
  const totalSelected = sortedData.reduce(
    (acc, curr) => acc + curr.selected,
    0
  );
  const totalJoined = sortedData.reduce(
    (acc, curr) => acc + (curr.joined || 0),
    0
  );
  const totalRevenue = sortedData.reduce(
    (acc, curr) => acc + (isNaN(curr.revenue) ? 0 : parseFloat(curr.revenue)),
    0
  );

  const totalRevenueTarget = sortedData.reduce((acc, curr) => {
    const correspondingRecord = data.find((record) => record.id === curr.user);
    const targetRev = correspondingRecord
      ? parseFloat(correspondingRecord.revenue) || 0
      : 0;
    return acc + targetRev;
  }, 0);

  const totalPercentage = (totalRevenue / totalRevenueTarget) * 100;

  return (
    <>
      <div style={{ display: "flex" }}>
        <CustomNavbar />
        <section style={{ width: "95vw", margin: "0 auto" }}>
          <div>
            <h3
              className="text-blue-500"
              style={{
                marginLeft: "30px",
                fontWeight: "800",
                // color: "var(--bs-blue)",
                marginTop: "10px",
              }}
            >
              Docladder Previous Month Records
            </h3>
              <table
                className="min-w-full bg-white border border-blue-500"
                style={{ width: "98.5%", margin: "auto" }}
              >
                <thead>
                  <tr className="bg-blue-500">
                    <th className="py-2 px-4 border-b">HR</th>
                    <th className="py-2 px-4 border-b">Name</th>
                    <th className="py-2 px-4 border-b">Forwarded</th>
                    <th className="py-2 px-4 border-b">Pipeline</th>
                    <th className="py-2 px-4 border-b">Turned Up</th>
                    <th className="py-2 px-4 border-b">Selected Candidate</th>
                    <th className="py-2 px-4 border-b">Joined</th>
                    <th className="py-2 px-4 border-b">Revenue</th>
                    <th className="py-2 px-4 border-b">Achievement Ratio</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-300">
                  {sortedData.map((dailyEntry) => {
                    const correspondingRecord = data.find(
                      (record) => record.id === dailyEntry.user
                    );
                    const imageSrc = correspondingRecord
                      ? `${API_BASE_URL}${correspondingRecord.image}`
                      : "";
                    const userName = correspondingRecord
                      ? correspondingRecord.name
                      : "";
                    const targetRev = correspondingRecord
                      ? correspondingRecord.revenue
                      : "";

                    const pipeline =
                      pipelineandturnedup.find(
                        (entry) => entry.user === dailyEntry.user
                      )?.pipline || "";

                    return (
                      <tr key={dailyEntry.user}>
                        <td className="py-2 px-4 border-b text-center">
                          {imageSrc && (
                            <img
                              src={imageSrc}
                              className="w-auto"
                              style={{ height: "100px" }}
                              alt=""
                            />
                          )}
                        </td>
                        <td className="py-2 px-4 border-b text-center">
                          {userName}
                        </td>
                        <td className="py-2 px-4 border-b text-center">
                          {dailyEntry.resume_forwarded}
                        </td>
                        {/* <td className="py-2 px-4 border-b text-center">{pipeline}</td> */}
                        <td className="py-2 px-4 border-b text-center">
                          {pipeline === ""
                            ? "0"
                            : pipeline !== undefined
                            ? pipeline
                            : 0}
                        </td>
                        <td className="py-2 px-4 border-b text-center">
                          {dailyEntry.turned_up}
                        </td>
                        <td className="py-2 px-4 border-b text-center">
                          {dailyEntry.selected}
                        </td>
                        <td className="py-2 px-4 border-b text-center">
                          {dailyEntry.joined || 0}
                        </td>
                        <td className="py-2 px-4 border-b text-center">
                          {isNaN(dailyEntry.revenue)
                            ? 0
                            : parseFloat(dailyEntry.revenue)}{" "}
                          / {targetRev} lac
                        </td>
                        <td
                          className={`py-2 px-4 border-b text-center ${
                            (dailyEntry.revenue / targetRev) * 100 <= 50
                              ? "text-red-500"
                              : (dailyEntry.revenue / targetRev) * 100 > 50 &&
                                (dailyEntry.revenue / targetRev) * 100 < 100
                              ? "text-yellow-500"
                              : (dailyEntry.revenue / targetRev) * 100 >= 100 &&
                                (dailyEntry.revenue / targetRev) * 100 <= 115
                              ? "text-green-500"
                              : "text-blue-500"
                          }`}
                        >
                          {dailyEntry.revenue !== 0
                            ? ((dailyEntry.revenue / targetRev) * 100).toFixed(
                                2
                              )
                            : 0}
                          %
                        </td>
                      </tr>
                    );
                  })}

                  {/* Totals Row */}
                  <tr>
                    <td className="py-2 px-4 border-b text-center font-bold">
                      Total
                    </td>
                    <td className="py-2 px-4 border-b"></td>
                    <td className="py-2 px-4 border-b text-center font-bold">
                      {totalForwarded}
                    </td>
                    <td className="py-2 px-4 border-b text-center font-bold">
                      {totalPipeline}
                    </td>
                    <td className="py-2 px-4 border-b text-center font-bold">
                      {totalTurnedUp}
                    </td>
                    <td className="py-2 px-4 border-b text-center font-bold">
                      {totalSelected}
                    </td>
                    <td className="py-2 px-4 border-b text-center font-bold">
                      {totalJoined}
                    </td>
                    {/* <td className="py-2 px-4 border-b text-center font-bold">{totalRevenue.toFixed(2)} lac</td> */}
                    <td className="py-2 px-4 border-b text-center font-bold">
                      {totalRevenue.toFixed(2)} /{" "}
                      {totalRevenueTarget.toFixed(2)} lac
                    </td>
                    <td className="py-2 px-4 border-b text-center font-bold">
                      {totalPercentage.toFixed(2)}%
                    </td>
                  </tr>
                </tbody>
              </table>
          </div>
        </section>
        {/* <Announcementslider /> */}
      </div>
    </>
  );
}

export default DocladderPrevMonthRecords;
